export default "__VITE_ASSET__BmgZrqbH__"